<template>
  <Drawer
    :width="EditRecipeDrawerOpened ? 1000 : 500"
    v-model="drawerOpened"
    class="recipeDetailDrawer"
    :title="currentRecipe.name"
    @on-close="close"
  >
    <Modal v-model="deleteRecipModel" @on-ok="deleteRecipe">
      <p>你确定要删除这个配方吗？</p>
    </Modal>
    <div class="wrap" v-if="!EditRecipeDrawerOpened">
      <div class="recipe-info">
        <div class="info-left">
          <div class="recipe-item NoId">
            <div>配方编号</div>
            <div>#{{ currentRecipe.NoId }}</div>
          </div>
          <div class="recipe-item status">
            <div>配方状态</div>
            <div>
              {{ statusToText(currentRecipe.status) }}
            </div>
          </div>
          <div class="recipe-item createdBy">
            <div>配方创建人</div>
            <div>
              {{ currentRecipe.createdBy ? currentRecipe.createdBy.name : "" }}
            </div>
          </div>
        </div>
        <div class="info-right">
          <div class="recipe-item customer">
            <div>客户名称</div>
            <div>
              {{ currentRecipe.customer ? currentRecipe.customer.name : "" }}
            </div>
          </div>
          <div class="recipe-item sales">
            <div>销售项目</div>
            <div>
              {{ currentRecipe.sales ? currentRecipe.sales.abbr : "" }}
            </div>
          </div>
          <div class="recipe-item createdAt">
            <div>配方创建时间</div>
            <div>
              {{ currentRecipe.createdAt }}
            </div>
          </div>
        </div>
      </div>
      <div class="recipe-table">
        <Table
          border
          :loading="tableLoading"
          :columns="columns"
          :data="currentRecipe.detail"
        >
        </Table>
      </div>
      <div class="verify-recipe" v-if="currentRecipe.status === 'reviewing'">
        <Button
          type="success"
          @click="verifiedRecipe({ id: currentRecipe._id, status: 'verified' })"
          ghost
          >合格</Button
        >
        <Button
          type="error"
          @click="verifiedRecipe({ id: currentRecipe._id, status: 'rejected' })"
          ghost
          >不合格</Button
        >
      </div>
      <Button
        class="editButton"
        style="margin: 20px 20px 0 0"
        @click="editRecipe"
        type="primary"
        ghost
        >修改配方</Button
      >
      <Button
        v-if="user.superAdmin"
        class="editButton"
        style="margin-top: 20px"
        @click="openDeleteRecipe"
        type="error"
        ghost
        >删除配方</Button
      >
    </div>
    <EditRecipeDrawer
      v-if="EditRecipeDrawerOpened"
      ref="EditRecipeDrawer"
      @closeDrawer="closeEditRecipeDrawer"
    />
  </Drawer>
</template>

<script>
import dayjs from "dayjs";
import { mapActions, mapState } from "vuex";
import { arrayIntersection } from "@/utils";
import EditRecipeDrawer from "./EditRecipeDrawer.vue";

export default {
  name: "RecipeDetailDrawer",
  components: {
    EditRecipeDrawer,
  },
  data() {
    return {
      drawerOpened: false,
      currentRecipe: {},
      tableLoading: false,
      EditRecipeDrawerOpened: false,
      deleteRecipModel: false,
      columns: [
        {
          title: "材料",
          key: "material",
          align: "left",
          minWidth: 130,
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  fontSize: 16,
                },
              },
              params.row.material
                ? params.row.material.model
                  ? params.row.material.model
                  : params.row.material.name
                : "错误"
            );
          },
        },
        {
          title: "比例",
          key: "ratio",
          align: "right",
          width: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.ratio ? (params.row.ratio * 100).toFixed(2) + "%" : ""
            );
          },
        },
      ],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.currentUser,
    }),
  },
  methods: {
    ...mapActions({
      verifyRecipeSales: "recipeSales/verifyRecipeSalesAction",
      updateRecipeSales: "recipeSales/updateRecipeSalesAction",
      deleteRecipeSales: "recipeSales/deleteRecipeSalesAction",
    }),
    statusToText(status) {
      if (this.recipeType) {
        return "";
      } else {
        if (status === "verified") {
          return "合格";
        } else if (status === "rejected") {
          return "不合格";
        } else if (status === "canceled") {
          return "已取消";
        } else {
          return "待审核";
        }
      }
    },
    openDrawer(recipe) {
      recipe.createdAt = dayjs(recipe.createdAt).format("YYYY-MM-DD HH:mm");
      this.currentRecipe = recipe;
      this.drawerOpened = true;
    },

    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    async verifiedRecipe(verify) {
      const data = {};
      data.status = verify.status;
      const recipe = await this.updateRecipeSales({ id: verify.id, data });
      recipe.createdAt = dayjs(recipe.createdAt).format("YYYY-MM-DD HH:mm");
      this.currentRecipe = recipe;
    },
    editRecipe() {
      this.EditRecipeDrawerOpened = true;
      this.$nextTick(() => {
        this.$refs.EditRecipeDrawer.openDrawer(this.currentRecipe);
      });
    },
    close() {
      this.EditRecipeDrawerOpened = false;
    },
    async closeEditRecipeDrawer(newRecipe) {
      this.EditRecipeDrawerOpened = false;
    },
    // 删除配方确认弹框
    openDeleteRecipe() {
      this.deleteRecipModel = true;
    },
    // 确认删除配方
    async deleteRecipe() {
      try {
        await this.deleteRecipeSales({ id: this.currentRecipe._id });
        this.drawerOpened = false;

        this.$Message.success(`删除成功`);
      } catch (error) {
        this.$Message.error(`删除失败: ${error}`);
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.wrap
  padding 20px

.recipe-info
  display flex
  justify-content space-between
  flex-wrap wrap
  padding 0 15px

.recipe-item
  font-size 15px
  flex 1
  margin-bottom 15px

.verify-recipe
  width 100%
  display flex
  justify-content space-around
  margin-top 20px
</style>